/**
 * @link https://mui.com/material-ui/react-progress/
 */

import CircularProgress from '@mui/material/CircularProgress';
import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';
import React from "react";
import ShowCode from "../../helpers/ShowCode.js";

export default function FactureeProgress() {
  return (
    <>
      <Box sx={{ display:'flex', mb:5 }}>
        <CircularProgress sx={{mr: 1}}/>
        <CircularProgress color="secondary" />
      </Box>
      <Box sx={{ mb:5 }}>
        <LinearProgress sx={{mb: 2}} />
        <LinearProgress color="secondary" />
      </Box>
      
      <ShowCode 
        codeString={`<>
  {/* Circular Progress */}
  <Box sx={{ display: 'flex', gap: 2 }}>
    <CircularProgress />
    <CircularProgress color="secondary" />
    <CircularProgress color="success" />
    <CircularProgress color="error" />
  </Box>
  
  {/* Linear Progress */}
  <Box sx={{ width: '100%', mt: 4 }}>
    <LinearProgress sx={{ mb: 2 }} />
    <LinearProgress color="secondary" sx={{ mb: 2 }} />
    <LinearProgress color="success" sx={{ mb: 2 }} />
    <LinearProgress color="error" />
  </Box>
</>`} 
        scope={{ React, CircularProgress, LinearProgress, Box }} 
      />
    </>
  );
}